import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getMediaUrl, getProfileImage } from "../../utils/helpers";
import { useNavigate } from "react-router-dom";
import { GetPaymentPacks, CreatePayment } from "../../services/api";

export default function AddCash() {

    const [packData, setPackData] = useState([]);

    const user = useSelector((state) => state.auth.user);
    const navigate = useNavigate();

    useEffect(() => {
        GetPaymentPacks()
            .then((res) => {
                setPackData(res.data);
            })
            .catch((err) => {
                console.log(err)
            });
    }, []);

    const OnSelectpack = async (card) => {
        console.log("card ", card);

        const payload =
        {
            packId: card?._id,
        };

        const createPaymentRes = await CreatePayment(payload);
        const data = createPaymentRes?.data;

        console.log("createPaymentRes ", data);

        navigate("/pay", {
            state: {
                orderId: data?.orderId,
                amount: data?.payload?.amount,
                upiId: data?.payload?.upiId,
                name: data?.payload?.payeeName,
                intentUrl: data?.payload?.intentUrl
            },
        });
    }

    return (
        <div className="min-h-screen bg-black text-white px-4 md:px-24 pt-[85px] pb-20 relative">
            <div className="w-full flex justify-center px-4 mt-8">
                {/* Card */}
                <div
                    className="
                    bg-[#1f1f1f] rounded-2xl p-4 shadow-lg
                    flex items-center justify-between gap-4
                    w-full md:w-[70%]
                    "
                >
                    {/* LEFT SIDE */}
                    <div className="flex items-center gap-4">
                        <img
                            src={getProfileImage(getMediaUrl(user?.ppImageURL))}
                            alt="profile"
                            className="w-14 h-14 rounded-full object-cover"
                        />

                        <div>
                            <p className="text-white text-lg font-semibold">{user?.name}</p>

                            <div className="flex items-center gap-2 text-white text-sm">
                                <span>My Coins:</span>
                                <img src="./images/goldcoin.png" alt="coin" className="w-6 h-6 rounded-full object-cover" />
                                <span className="font-semibold">{user?.walletBalance.toFixed(2)}</span>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT SIDE */}
                    <div className="flex items-center gap-2 bg-[#2c2c2c] py-2 px-4 rounded-full">
                        <img
                            src={user?.countryId?.flag}
                            alt="flag"
                            className="w-6 h-4 rounded-sm"
                        />
                    </div>
                </div>
            </div>

            <div className="w-full flex justify-center px-4 mt-4">

                {/* WRAPPER TO CENTER TITLE + CONTAINER */}
                <div className="w-full md:w-[70%]">

                    {/* TITLE (left aligned but centered as a group) */}
                    <div className="flex justify-between">
                        <h2 className="text-white text-xl font-semibold mb-6">
                            Choose Coin Package
                        </h2>
                        <a href="/transactions" className="underline font-semibold">Transaction History</a>
                    </div>

                    {/* COIN CONTAINER */}
                    <div className="bg-[#1f1f1f] rounded-2xl p-6">

                        {/* GRID */}
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                            {packData.map((card, index) => (
                                <div
                                    key={index}
                                    onClick={() => OnSelectpack(card)}
                                    className="
                                        bg-[#2a2a2a]
                                        rounded-xl
                                        p-3               /* smaller padding on mobile */
                                        sm:p-4            /* normal padding on larger screens */
                                        border border-gray-700
                                        flex flex-col items-center text-center
                                        relative
                                        hover:border-gray-500
                                        transition
                                    "
                                >

                                    {/* Badge */}
                                    {card.badge && (
                                        <span className="
                                            absolute top-2 left-2
                                            bg-red-500 text-white text-[10px]   /* smaller text */
                                            px-1.5 py-0.5                        /* reduced badge padding */
                                            rounded-md font-semibold
                                            sm:text-xs sm:px-2 sm:py-1          /* normal size on bigger screens */
                                        ">
                                            {card.badge}
                                        </span>
                                    )}

                                    {/* Coin Image */}
                                    <img
                                        src={card.img}
                                        alt="coins"
                                        className="w-14 h-14 mt-2 sm:w-20 sm:h-20 sm:mt-4"
                                    />

                                    {/* Coins Text */}
                                    <p className="
                                        text-white
                                        text-xl sm:text-3xl                   /* smaller on mobile */
                                        font-bold
                                        mt-2
                                    ">
                                        {card.coins}
                                    </p>

                                    {/* Price */}
                                    <p className="text-gray-200 text-base sm:text-lg font-semibold mt-1">
                                        {card.price}
                                    </p>

                                    {/* Old Price */}
                                    {card.oldPrice && (
                                        <p className="text-gray-500 line-through text-xs sm:text-sm">
                                            {card.oldPrice}
                                        </p>
                                    )}

                                </div>
                            ))}
                        </div>

                    </div>

                    {/* FOOTER LINKS */}
                    <div
                        className="
                            flex flex-col sm:flex-row 
                            justify-between items-center 
                            mt-6 text-white text-sm gap-3 sm:gap-0
                        "
                    >
                        {/* Terms + Privacy */}
                        <div className="flex gap-1 text-center sm:text-left">
                            <a href="/terms" className="underline font-semibold">Terms of Service</a>
                            <span>&</span>
                            <a href="/privacy" className="underline font-semibold">Privacy Policy</a>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    );
}